export default __webpack_public_path__ + "static/media/angers12.57757f33.jpg";